export type SettingsTabId =
  | "ai"
  | "reactivation"
  | "schedule"
  | "matching-profile"
  | "training-teens"
  | "groups"
  | "dev";

export interface SettingsTabVisibility {
  isSuperAdmin: boolean;
  showSchedule: boolean;
  showMatchingProfile: boolean;
  canReadTrainingTeenContent: boolean;
  canReadGroups: boolean;
  showDevSettings: boolean;
}

export function visibleSettingsTabs(
  visibility: SettingsTabVisibility,
): SettingsTabId[] {
  const tabs: SettingsTabId[] = [];
  if (visibility.isSuperAdmin) {
    tabs.push("ai", "reactivation");
  }
  if (visibility.showSchedule) tabs.push("schedule");
  if (visibility.showMatchingProfile) tabs.push("matching-profile");
  if (visibility.canReadTrainingTeenContent) tabs.push("training-teens");
  if (visibility.canReadGroups) tabs.push("groups");
  if (visibility.showDevSettings) tabs.push("dev");
  return tabs;
}

export function resolveSettingsVisibleTab(
  selectedTab: string,
  visibility: SettingsTabVisibility,
): SettingsTabId | null {
  const tabs = visibleSettingsTabs(visibility);
  if (tabs.includes(selectedTab as SettingsTabId)) {
    return selectedTab as SettingsTabId;
  }
  return tabs[0] ?? null;
}
